import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { submitShowcaseOrder, reqSubmitShowcaseOrder } from '../../Apis';

export const SaveShowCaseOrder = createAsyncThunk('get showcase based on cat', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await submitShowcaseOrder(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const SubmitRequirements = createAsyncThunk('SubmitRequirements', async ({ formData, token }, { rejectWithValue }) => {
    try {

        const response = await reqSubmitShowcaseOrder(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});



const showcasePaymentSlice = createSlice({
    name: 'showcasePayment',
    initialState: {
        error: null,
        success: false,
        data: {},
        submitDone : false

    },
    reducers: {
        clearShowPaymentStatus: state => {
            state.success = false;
            state.error = null;
        },

    },
    extraReducers: builder => {
        builder
            .addCase(SaveShowCaseOrder.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(SaveShowCaseOrder.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.data = action.payload.data.data;
            state.submitDone = true;

            })
            .addCase(SaveShowCaseOrder.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(SubmitRequirements.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(SubmitRequirements.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;

            })
            .addCase(SubmitRequirements.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })

    },

});
export const { clearShowPaymentStatus, } = showcasePaymentSlice.actions;
export default showcasePaymentSlice.reducer;

